module.exports = __webpack_public_path__ + "img/delivery-notes.d36a344a.svg";